// removed by extract-text-webpack-plugin
module.exports = {"link":"_1-im0Ib","chevron":"_3DOOCiV","chevronSvg":"_2elBAHF"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/TextLink/TextLink.less
 ** module id = 626
 ** module chunks = 0
 **/